import { call, put, select } from 'redux-saga/effects';

import { setUsers } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import AnalyticsService from '../../../../services/analytics.service';

export default function* getUsers() {
  const {
    uuid: organizationId,
    orgType: organizationType,
    profile: { organizations = {} } = {},
  } = yield select((state) => state.organization);
  const { user } = yield select((state) => state);
  const { signUpRole, productInterest } = yield select((state) => state.user);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl}${RESOURCES.V3}/organizations/${organizationId}/users`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });
    if (success && !error) {
      const currUser = result.find((r) => r.userId === user.id);
      const { createdDate } = organizations[0] || {};
      const dateWithoutTime = createdDate.split('T')[0];
      const createdDateWithoutTime = `${dateWithoutTime}T00:00:00.000+00:00`;
      const orgTraits = {
        ...currUser?.organization,
        createdDate,
        organizationType,
        createdDateWithoutTime,
      };
      delete orgTraits.role;
      const userTraits = {
        ...currUser,
        role: currUser?.organization?.role,
        organization: orgTraits,
        signUpRole,
        productInterest,
      };
      AnalyticsService.identifyUser(userTraits.userId, userTraits);
      yield put(setUsers(result));
    }
  } catch (e) {
    console.error(e);
  }
}
